import { ModulesService } from './../modules.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FeaturesService } from '../features.service';
import { MetaService } from '../meta.service';

@Component({
  selector: 'app-documentation',
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.css']
})
export class DocumentationComponent implements OnInit {

  //declare variables
  strBase: string = 'assets/kb/';
  strSource: string = '';
  modules: any[] = [];
  features: any[] = [];

  //inject services
  constructor(private mds: MetaService, private ms: ModulesService, private route: ActivatedRoute, private fs: FeaturesService) { }

  //initialize the component
  ngOnInit(): void {
    //get the list of modules
    this.modules = this.ms.getModuleList();

    //get the list of features
    this.features = this.fs.getFeatures();

    //get the parameters passed to the component
    this.route.paramMap.subscribe(p => {
      //get the link passed
      var strLink = p.get('module');

      //make sure something was passed
      if (strLink == '' || strLink == null) {
        //set default
        this.strSource = this.strBase + 'overview.md';
      } else {
        this.strSource = this.strBase + strLink + '.md';
      }
    });

    //SEO Optimization
    var strTitle = 'RegScale - Documentation';
    var description = 'RegScale documentation for installation, configuration, and use of our Compliance Platform';
    var keywords = 'RegScale, documentation, knowledge base, tech articles, tutorials, installation, configuration';
    this.mds.updateTags(strTitle, keywords, description);
  }

}
